import { loadStripe } from '@stripe/stripe-js'

const { REACT_APP_STRIPE_PUBLISHABLE_KEY } = process.env

export const stripeProvider = loadStripe(String(REACT_APP_STRIPE_PUBLISHABLE_KEY), {
  locale: 'en'
})
